import { Mode, plugin } from 'light-component';
import { useTranslation } from '../../../i18n';
import { Thumbnail } from '../../component';
import { WidgetType } from '../types';
import { ShotEyesAmountDesignMode } from './design';
import { ShotEyesAmountInputMode } from './input';
import { ShotEyesAmountViewMode } from './view';
import type { ShotEyesAmountProps } from './types';
import type { ReactElement } from 'react';

// 奖罚配单-数额PENALTIES
export function PenaltiesAmount(props: ShotEyesAmountProps): ReactElement | null {
  const [t] = useTranslation();

  if (props.mode === Mode.THUMBNAIL) {
    return (
      <Thumbnail icon='ShotEyesAmountIcon' title={t('ShotEyesAmount')}
        toolTipContent={t('奖罚数额，仅可输入数字')} />
    );
  }

  if (props.mode === Mode.DESIGN) {
    return (<ShotEyesAmountDesignMode {...props} />);
  }

  if (props.mode === Mode.VIEW) {
    return (<ShotEyesAmountViewMode {...props} />);
  }

  if (props.mode === Mode.INPUT) {
    return (<ShotEyesAmountInputMode {...props} />);
  }

  return null;
}

PenaltiesAmount.prototype.type = WidgetType.SHOTEYES_AMOUNT;
plugin.register({ kind: 'widget', component: PenaltiesAmount });
